import CircleMembersController from "./members";

export default class CircleStaffController extends CircleMembersController {
  circleMembershipType = "staff";
}
